<template>
  <div class="get-certified-container">
    <div class="get-certified">
      <div class="container">
        <div class="text-center font-montserrat-sb">
          <h1 data-aos="fade-left" class="text-white mb-5"> {{ text }} </h1>
          <div class="d-flex justify-content-center">
            <ButtonHover @click="handleClick" data-aos="flip-left" :btn-text="btnText" backgroundColor="#A4C615"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonHover from './ButtonHover.vue'

export default {
  props: {
    btnText: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    handleClick: {
      type: Function,
      default: () => {}
    }
  },
  components: {
    ButtonHover
  }
}
</script>

<style scoped>

  .get-certified-container {
    width: 100%;
    min-width: 320px;
    height: 35em;
    background-image: url(../assets/images/hens.jpg);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .get-certified {
    display: grid;
    place-items: center;
    height: 100%;
    background-color: rgba(29, 59, 32, 0.6)
  }

  .get-certified h1 {
    line-height: 50px;
  }

</style>
